#import "./DocumentFileDistributionsByDocumentFileId.graphql"
subscription OnDocumentUploadStatus($documentId: UUID!) {
  documentUploadStatus(documentId: $documentId) {
    document {
      id
      entityId
      _documentContents
      _isAccountingDocument
      _isDocumentAmountApplied
      isAppliedAmountRetired

      isAppliedAmountOverage
      documentRetiredAmount
      entityDocumentTypeId
      fileIndexInformation
      _isDocumentTypeUpdatable
      _poAllocationTotal
      comment
      documentTypeId
      documentTypes {
        id
        documentType
        isAccountingDocument
        isSigningRequired
        _isAppliableDocumentType
        transactionTypeId
        _isMultiDocumentBundleAllowed
        _isPoSystemDocument
      }
      documentStatusType {
        statusType
      }
      documentStatusExplanation
      documentOverageAmount
      _isDocumentAmountAvailable
      documentAppliedAmounts {
        id
        appliedTotal
        overageTotal
        retiredTotal
        usedTotal
        remainingTotal
        _isRemainingAmountAvailable
        _isRetiringBalanceAllowed
      }
      currency {
        isoCode
      }
      _documentPoolName
      _documentPoolId
      indexName
      indexAmount
      indexCurrencyId
      indexDescription
      indexReferenceNumber
      indexTransactionDate
      _isReportingDocument
      _sharedByUser
      _fileName
      _fileType
      _fileViewer
      _createdDate
      _isDocumentShare
      fileReference
      iconType
      _fileSize
      rowSecurityId
      entityDocumentSecureRowLevels {
        id
        description
        name
        securityLevel
      }
      _uploadDate
      _rowTimestamp
      _isLoading
      _isDeletable
      _isUpdatable
      _isProtected
      _isSelected
      isShareable
      _isLoadFailed
      documentAppliedAmount
      paymentDocument {
        _isApprovalDocumentsRequired
      }
      invoiceDocument {
        _isApprovalDocumentsRequired
      }
      extractionTypeId
      ...DocumentFileDistributionsByDocumentFileId
      invoiceDocument {
        id
        _isApprovalDocumentsRequired
        _requiredApprovalDocuments
        _isStagedApprovalRequest
      }
      paymentDocument {
        id
        _isApprovalDocumentsRequired
        _requiredApprovalDocuments
      }
      payCycleDocument {
        id
        _isApprovalDocumentsRequired
        _requiredApprovalDocuments
      }
      extractionType {
        isExtractProtected
      }
      lookupName {
        lookupName
        id
        isApprovedVendor
        lookupCode
        lookupName
        lookupName2
        address1
        address2
        city
        state
        zipCode
        country
        phone
        emailAccount
      }
      indexTaxCode1
      indexTaxAmount1
      indexTaxAccount1
      indexTaxCode2
      indexTaxAmount2
      indexTaxAccount2
      indexTaxCode3
      indexTaxAmount3
      indexTaxAccount3
      indexTaxCode4
      indexTaxAmount4
      indexTaxAccount4
      documentPosition
    }
    status {
      type
      message
    }
  }
}
